import React from 'react'

import { SaveButton, DeleteWithConfirmButton, useRecordContext, TextInput } from 'react-admin'
import WarningIcon from '@mui/icons-material/Warning';
// import { BoxedShowLayout } from 'ra-compact-ui';

import { FormHeaderInput } from './FormHeaderInput'
import { SettingsGroup } from 'shared/organisms/settings_group'
import { Link } from 'react-router-dom';

const SettingsSection: React.FC<{ title: string; subtitle?: string }> = (props) => {
  const { title = 'Group', subtitle, children } = props

  return <>{children}</>
}

export const FormSettings = (props) => {
  const { className, ...rest } = props
  let record = useRecordContext()

  return (
    <div style={{ marginTop: 20 }}>
      <SettingsSection title="General">
        <SettingsGroup name="Form Name" description="The name this form will be referred to in the PowCloud dashboard.">
          <TextInput source="name" fullWidth />
        </SettingsGroup>
        <SettingsGroup name="Form Header" description="Custom header to be displayed at the top of your form">
          <FormHeaderInput source="header" label={false} fullWidth />
        </SettingsGroup>
      </SettingsSection>
      <SettingsSection title="Advanced">
        <SettingsGroup name="Redirect URL" description="Form will redirect to this URL on successful submission">
          <TextInput
            label="Redirect URL"
            source="redirectUrl"
            defaultValue={null}
            type="url"
            fullWidth
            helperText="must be a valid url"
          />
        </SettingsGroup>
        {/* <SettingsGroup name="Display Settings" description="Control how your form is displayed" locked>
          <BooleanInput source="show_branding" default={true} label="Show Formtopia branding" disabled />
        </SettingsGroup>

        <SettingsGroup
          name="Form Page Metadata"
          description="Customize what is displayed when you share your public form URL."
          locked
        >
          <TextInput source="meta_title" fullWidth disabled />
          <TextInput source="meta_description" fullWidth disabled />
        </SettingsGroup>

        <SettingsGroup name="On Form Submission" description="What happens when a form is completed" locked>
          <RadioButtonGroupInput
            disabled={true}
            source="on_entry_action"
            choices={[
              { id: 'custom', name: 'Show a message', disabled: true },
              { id: 'redirect', name: 'Redirect to URL', disabled: true },
            ]}
          />

          <TextInput
            source="on_entry_message"
            // initialValue="Thank you for submitting this form."
            fullWidth
            multiline
            disabled={true}
          />
          <TextInput source="on_entry_redirect_url" fullWidth disabled={true} />
        </SettingsGroup> */}
      </SettingsSection>
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <SaveButton />
        <DeleteWithConfirmButton
          confirmTitle={`Are you sure you want to delete "${record.name}"?`}
          confirmContent={
            <div>
              <p style={{ display: 'flex', alignItems: 'center' }}>
                <WarningIcon sx={{ color: '#eed202' }} />
                <div style={{ marginLeft: 10, fontWeight: 'bold' }}>This cannot be undone!</div>
              </p>
              <p>
                Before you continue, be sure to <Link to='entries'>export your form entries</Link>. Proceeding will permanently delete the form and all data entries associated with it.
              </p>
            </div>
          }
        />
      </div>
    </div>
  )
}
